import { useRouter } from 'next/router';

import { PLP_SUBCATEGORIES } from 'shared/enums/category';

export const useEventContext = () => {
  const {
    route,
    query: { query: searchQuery },
  } = useRouter();
  const categoryPages = ['/accessories', '/apparel', '/bags', '/jewelry', '/sneakers'];
  const isNestedCategoryPage = PLP_SUBCATEGORIES.has(route?.split('/')?.[2]);

  if (route.includes('/brand')) {
    return 'brand_page';
  }
  if (isNestedCategoryPage || categoryPages.includes(route)) {
    return 'categories';
  }
  if (route.includes('/collections')) {
    return 'collection';
  }
  if (route.includes('/search') && searchQuery) {
    return 'search_results';
  }
  if (route.includes('/search') && !searchQuery) {
    return 'shop_all';
  }
  if (route.includes('/timeline')) {
    return 'timeline';
  }
  if (route.includes('/wants')) {
    return 'wants';
  }
  return 'pdp';
};
